import * as z from 'zod';

import type { RouteListItem } from '@/types';

import { settingsBcLink } from '../../model';

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/email-history', name: 'Email History' },
];

export const deliveryStatusValues = ['scheduled', 'pending', 'accepted', 'delivered', 'failed', 'quarantined'] as const;

export const deliveryStatusSchema = z.enum(deliveryStatusValues);

export type DeliveryStatusSchema = z.infer<typeof deliveryStatusSchema>;

const deliveryStatusLabels: Record<DeliveryStatusSchema, string> = {
  scheduled: 'Scheduled',
  pending: 'Pending',
  accepted: 'Accepted',
  delivered: 'Delivered',
  failed: 'Failed',
  quarantined: 'Quarantined',
};

export function getDeliveryStatusLabel(status: string): string {
  if (status in deliveryStatusLabels) {
    return deliveryStatusLabels[status as DeliveryStatusSchema];
  }

  return status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export const deliveryStatusOptions = deliveryStatusValues.map((value) => ({
  name: deliveryStatusLabels[value],
  value,
}));
